/**
 * Page Level values.  this should include request params.
 *
 */

module.exports = {
    values: function() {
        return window.EDM.PageValues;
    },
    visitor: function() {
        return window.EDM.visitor;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/page-values/page-values.js
// module id = 261
// module chunks = 36